<template>
    <div class="center">
        <p class="pd" style="display: flex;align-items: center">原因:<el-input v-model.trim="input" style="width: 200px" :placeholder="selectVal.goodsName"></el-input></p>
        <span slot="footer" class="dialog-footer"  style="padding-bottom: 20px">
    <el-button @click="cancel">{{$t('button_cancel')}}</el-button>
    <el-button type="primary" @click="cancel1">确 定</el-button>
  </span>
    </div>
</template>
<script>
    import * as API from  "../api";
    import {mapActions} from "vuex";
    import data from "../data.json"
    export default {
        name: 'activateDialog',
        props:{
            selectVal:{
                type:Object,
            required:true},

        },
        data() {
            return {
                input: '',
                center:false
            }
        },
        mounted() {
            //console.log(this.input)
            // this.$parent.getOrderManagerList()
        },
        destroyed(){


        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            cancel(){
                this.$emit('close')
            },
            cancel1(){
                    this.jihuodingdan()
                // this.$emit('getOrderManagerList',this.center)
            },
            //激活订单
            async jihuodingdan(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };

                let param={
                    id:this.selectVal.id,
                    token:sessionStorage.getItem("token"),
                    version:"",
                    app:"",
                    i_uid:sessionStorage.getItem("userid"),
                    reason:this.input,
                    i_mid:this.mid
                };
                let res=await API.jihuoorder(param)
                if(res.code==1){
                    // this.select=res.list.status;
                    // this.select1=res.list.isConsignShip;
                    //console.log(res)
                    this.total=res.data.total
                    this.$emit('getOrderManagerList',this.center)

                } else if (res.code == -2) {
                    this.$router.push('/login')
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };

            },

        }
    }
</script>
<style lang="scss" scoped>
    .center{
        display: flex;
        align-items: center;
        flex-direction:column;
    }
    .pd{
        padding: 20px 0 0 0;
    }
</style>